"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.ensurePermissions = exports.isAuthorizationConfig = exports.transformAuthorizationConfigToRoles = exports.transformRolesToAuthorizationConfig = void 0;
var lodash_1 = require("lodash");
var fp_1 = require("lodash/fp");
var wix_data_schema_types_1 = require("@wix/wix-data-schema-types");
var authorizationConfig_1 = require("./types/authorizationConfig");
var permissionsPresets_1 = require("./permissionsPresets");
var publicRoles = [
    wix_data_schema_types_1.PermissionRole.anyone,
    wix_data_schema_types_1.PermissionRole.siteMember,
    wix_data_schema_types_1.PermissionRole.siteMemberAuthor,
    wix_data_schema_types_1.PermissionRole.admin
];
var defaultRole = wix_data_schema_types_1.PermissionRole.admin;
var legacyRoles = [
    authorizationConfig_1.LegacyRole.anonymous,
    authorizationConfig_1.LegacyRole.siteMember,
    authorizationConfig_1.LegacyRole.dataOwner,
    authorizationConfig_1.LegacyRole.siteOwner
];
var operations = [
    'insert',
    'update',
    'remove',
    'read'
];
var isAuthorizationConfig = function (permissions) {
    return lodash_1.isEmpty(fp_1.xor(legacyRoles, Object.keys(permissions).filter(function (k) { return k !== 'meta'; })));
};
exports.isAuthorizationConfig = isAuthorizationConfig;
var withDefaultPermissions = function (schema) { return (__assign(__assign({}, schema), { permissions: permissionsPresets_1.getPermissionsByPreset(permissionsPresets_1.Preset.PRIVATE_DATA) })); };
var containsRequiredProperties = function (permissions) {
    return operations.every(function (operation) {
        return publicRoles.includes(permissions[operation]);
    });
};
var ensurePermissions = function (schema) {
    if (!schema.permissions) {
        return withDefaultPermissions(schema);
    }
    if (isAuthorizationConfig(schema.permissions)) {
        return __assign(__assign({}, schema), { permissions: transformAuthorizationConfigToRoles(schema.permissions) });
    }
    if (!containsRequiredProperties(schema.permissions)) {
        return withDefaultPermissions(schema);
    }
    return schema;
};
exports.ensurePermissions = ensurePermissions;
var transformAuthorizationConfigToRoles = function (authorizationConfig) {
    if (!lodash_1.isObject(authorizationConfig)) {
        return null;
    }
    return operations.reduce(function (roles, operation) {
        var _a;
        return Object.assign(roles, (_a = {},
            _a[operation] = getPublicPermissionValue({
                operation: operation,
                authorizationConfig: authorizationConfig
            }),
            _a));
    }, {});
};
exports.transformAuthorizationConfigToRoles = transformAuthorizationConfigToRoles;
var transformRolesToAuthorizationConfig = function (permissions) {
    return publicRoles.reduce(function (authorizationConfig, role, index) {
        var _a;
        var internalRole = legacyRoles[index];
        return Object.assign(authorizationConfig, (_a = {},
            _a[internalRole] = getInternalPermissionValue({
                role: role,
                permissions: permissions
            }),
            _a));
    }, {});
};
exports.transformRolesToAuthorizationConfig = transformRolesToAuthorizationConfig;
var getPublicPermissionValue = function (_a) {
    var operation = _a.operation, authorizationConfig = _a.authorizationConfig;
    return publicRoles.reduce(function (selectedRole, role, index) {
        var internalRole = legacyRoles[index];
        return !selectedRole && authorizationConfig[internalRole][operation]
            ? role
            : selectedRole;
    }, null) || defaultRole;
};
var roleSupportsOperation = function (role, operation) { return role !== wix_data_schema_types_1.PermissionRole.siteMemberAuthor || operation !== 'insert'; };
var isOperationEnabledForRole = function (_a) {
    var selectedRoleForOperation = _a.selectedRoleForOperation, role = _a.role;
    var operationRoleIndex = publicRoles.indexOf(selectedRoleForOperation);
    var roleIndex = publicRoles.indexOf(role);
    return roleIndex >= operationRoleIndex;
};
var getInternalPermissionValue = function (_a) {
    var role = _a.role, permissions = _a.permissions;
    return operations
        .filter(function (operation) { return roleSupportsOperation(role, operation); })
        .reduce(function (rolePermissions, operation) {
        var _a;
        return Object.assign(rolePermissions, (_a = {},
            _a[operation] = isOperationEnabledForRole({
                selectedRoleForOperation: permissions[operation],
                role: role
            }),
            _a));
    }, {});
};
//# sourceMappingURL=permissions.js.map